import React, { useCallback, useRef } from "react";
import { Blocker, type BlockerFunction, useBlocker } from "react-router";
import { BlockerContext } from "./BlockerContext";

export const BlockerProvider = ({ children }: { children: React.ReactNode }) => {
  const blockersRef = useRef<Set<BlockerFunction>>(new Set());

  const register = useCallback((fn: BlockerFunction) => {
    blockersRef.current.add(fn);
    return () => blockersRef.current.delete(fn);
  }, []);

  const shouldBlock = useCallback((...v: Parameters<BlockerFunction>) => {
    for (const fn of blockersRef.current) {
      if (fn(...v)) {
        return true;
      }
    }
    return false;
  }, []);

  const blocker = useBlocker(shouldBlock);
  const proceed = () => {
    if (blockersRef.current.size <= 1) blocker.proceed?.();
  };
  return <BlockerContext.Provider value={{ blocker: { ...blocker, proceed } as Blocker, register }}>{children}</BlockerContext.Provider>;
};
